import { withStyles } from '@mui/styles';
import AccountMenu from './Account';
import { default as WrAppBar } from '@proofpoint/fuse/components/AppBar';
import { useTheme } from '@mui/material/styles';


const styles = {
  grow: {
    flexGrow: 1,
  }
};

const AppBar = ({classes}) => {
  const theme = useTheme();
  return (
      <WrAppBar 
        companyLogo={
          theme.palette.mode === 'dark' ?
          <img src="/cloudmark_logo_dark.svg" width="210" alt="Cloudmark logo" /> :
          <img src="/cloudmark_logo.svg" width="210" alt="Cloudmark logo" />
        } 
        productName="Customer Accuracy Tools">
        <div className={classes.grow} />
        <AccountMenu />
      </WrAppBar>
  );
};

export default withStyles(styles)(AppBar);
